<template>
	<div id="centerWidth" :style="{ height: windowHeight + 'px' }" style="overflow: auto;"
		@scroll="scrollEvent($event)">
		<div class="centerWidth" @scroll="scrollEvent($event)">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>查.高校查询</span>
			</div>
			<section class="gaokao-content">
				<!-- 意向院校 -->
				<div class="tb_yx">
					<article class="tb_zye ">
						<!-- 22-02-14 -->
						<div class="yi_xiang">
							<ul>
								<li class="flex float">
									<div class="pyx_h6">院校属地</div>
									<div class="pyx_you flex wrap">
										<p :class="item.isSelect ? 'on' : ''" @click="ChooseItem(index,1)"
											v-for="(item, index) in collegeAddressList" :key="index">{{ item.name }}</p>
									</div>
								</li>
								<li class="flex float">
									<div class="pyx_h6">院校类型</div>
									<div class="pyx_you flex wrap">
										<p :class="item.isSelect ? 'on' : ''" @click="ChooseItem(index,2)"
											v-for="(item, index) in collegeTypeList" :key="index">
											{{ item.name }}
										</p>
									</div>
								</li>
								<li class="flex float">
									<div class="pyx_h6">院校特色</div>
									<div class="pyx_you flex wrap">
										<p :class="item.isSelect? 'on' : ''" @click="ChooseItem(index,3)"
											v-for="(item, index) in collegeCharacteristic" :key="index">
											{{ item.name }}
										</p>
									</div>
								</li>
								<li class="flex float">
									<div class="pyx_h6">院校类别</div>
									<div class="pyx_you flex wrap">
										<p :class="item.isSelect? 'on' : ''" @click="ChooseItem(index,4)"
											v-for="(item, index) in collegeCategory" :key="index">
											{{ item.name }}
										</p>
									</div>
								</li>
								<li class="flex float">
									<div class="pyx_h6">院校搜索</div>
									<div class="pyx_you flex ">
										<div class="tba_dl flex zhong">
											<div class="tba_input" style="width: 200px;">
												<el-input placeholder="请输入院校名称" v-model="searchKey"></el-input>
											</div>
										</div>
										<div class="flex zhong">
											<button class="gaokao-btn" style="width: 120px;margin: 0 0 0 20px;"
												@click="GetCollegeList(1)">搜索</button>

										</div>
									</div>
								</li>
							</ul>
						</div>
					</article>

					<!-- 02 -->
					<div class="tbb_box flex float">
						<article class="tb_zy_left">
							<article class="table">
								<hgroup class="flex">
									<p>学校名称</p>
									<p>院校属地</p>
									<p>院校类型</p>
									<p>院校类别</p>
									<p>院校特色</p>
									<p>主管部门</p>
									<p>查看</p>
								</hgroup>
								<ul v-infinite-scroll="GetMore" infinite-scroll-disabled="busy2"
									infinite-scroll-distance="10">
									<li class="flex zhong" v-for="(item,index) in collegeList" :key="index" @click="GoSchool(item.SchoolName)">
										<p style="color: #0079fe;cursor: pointer;" >
											{{ item.SchoolName }}</p>
										<p>{{ item.Location }}</p>
										<p>{{ item.Type1 }}</p>
										<p>{{ item.Type2 }}</p>
										<p>{{ item.Feature }}</p>
										<p>{{ item.Director }}</p>
										<p class="flex zhong center">
											<span >院校详情</span>
										</p>
										
										
									</li>
								</ul>
							</article>
							<!-- <div v-loading="busy2" class="loading " />
							<div v-if="listName.length === 0" style="text-align: center" class="shuJu">暂无数据</div>
							<div v-if="Nobusy2" style="text-align: center" class="shuJu">已加载完了</div> -->
						</article>

					</div>
				</div>
				<!-- <div class="flex xend major-page">
                <el-pagination background layout="prev, pager, next" :page-size="pageSize" @current-change="GetPageList" :current-page="page" :total="totleNum"></el-pagination>
            </div> -->
			</section>
		</div>
	</div>
</template>

<script>
	import infiniteScroll from 'vue-infinite-scroll';
	export default {
		directives: {
			infiniteScroll
		},
		data() {
			return {
				// 22-2-14
				loading: false,
				finished: false,
				show: false,
				isYuanShua: 0,
				collegeAddressList: [{
						isSelect: true,
						name: '不限'
					},
					{
						isSelect: false,
						name: '北京市'
					},
					{
						isSelect: false,
						name: '河北省'
					},
					{
						isSelect: false,
						name: '山西省'
					},
					{
						isSelect: false,
						name: '辽宁省'
					},
					{
						name: '吉林省'
					},
					{
						isSelect: false,
						name: '黑龙江省'
					},
					{
						isSelect: false,
						name: '江苏省'
					},
					{
						isSelect: false,
						name: '浙江省'
					},
					{
						isSelect: false,
						name: '安徽省'
					},
					{
						isSelect: false,
						name: '福建省'
					},
					{
						isSelect: false,
						name: '江西省'
					},
					{
						isSelect: false,
						name: '山东省'
					},
					{
						isSelect: false,
						name: '河南省'
					},
					{
						isSelect: false,
						name: '湖北省'
					},
					{
						isSelect: false,
						name: '湖南省'
					},
					{
						isSelect: false,
						name: '广东省'
					},
					{
						isSelect: false,
						name: '海南省'
					},
					{
						isSelect: false,
						name: '四川省'
					},
					{
						isSelect: false,
						name: '贵州省'
					},
					{
						isSelect: false,
						name: '云南省'
					},
					{
						isSelect: false,
						name: '陕西省'
					},
					{
						isSelect: false,
						name: '甘肃省'
					},
					{
						isSelect: false,
						name: '青海省'
					},
					{
						isSelect: false,
						name: '台湾省'
					},
					{
						isSelect: false,
						name: '内蒙古'
					},
					{
						isSelect: false,
						name: '广西壮族'
					},
					{
						isSelect: false,
						name: '西藏'
					},
					{
						isSelect: false,
						name: '宁夏回族'
					},
					{
						isSelect: false,
						name: '新疆维吾尔'
					},
					{
						isSelect: false,
						name: '天津市'
					},
					{
						isSelect: false,
						name: '上海市'
					},
					{
						isSelect: false,
						name: '重庆市'
					},
					{
						isSelect: false,
						name: '香港'
					},
					{
						isSelect: false,
						name: '澳门'
					}
				],

				collegeTypeList: [{
					isSelect: false,
					name: '不限'
				}], //院校类型

				collegeCharacteristic: [{
						isSelect: true,
						name: '不限'
					},
					{
						isSelect: false,
						name: '985'
					},
					{
						isSelect: false,
						name: '211'
					},
					{
						isSelect: false,
						name: '双一流'
					},
					{
						isSelect: false,
						name: '国家重点'
					},
					{
						isSelect: false,
						name: '省重点'
					}
				], // 院校特色
				collegeCategory: [{
						isSelect: true,
						name: '不限'
					},
					{
						isSelect: false,
						name: '公办'
					},
					{
						isSelect: false,
						name: '民办'
					},
					{
						isSelect: false,
						name: '中外/港澳'
					}
				], //院校类别
				collegeList:[],
				page:1,
				hotList: [{}, {}, {}, {}, {}],
				isHot: 0,
				isAllBox: true,
				searchKey:''

			};
		},
		// 加载
		created() {
			console.log("11111")
			this.getCollegesMold();
			// this.cityList = this.$store.state.shop.currentProvince;
			// this.GetList(1);
			this.GetCollegeList(1);
			if (this.$route.query.key) {
				this.$api.reduceUserCount({
					key: this.$route.query.key
				});
			} else {
				this.$router.back(-1);
			}
			this.getRegionByPid(0);
			
		},
		watch: {
			windowHeight(val) {
				const that = this;
				console.log('实时屏幕高度：', val, that.windowHeight);
			}
		},
		mounted() {
			const that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.windowHeight = window.fullHeight;
				})();
			};
		},
		methods: {
			onYuanShua(index) {
				this.isYuanShua = index;
			},
			onYuanShub(index) {
				this.isYuanShub = index;
			},
			onYuanShuc(index) {
				this.isYuanShuc = index;
			},
			onYuanShud(index) {
				this.isYuanShud = index;
			},
			onHotTab(index) {
				this.isHot = index;
			},
			// 获取院校类型
			getCollegesMold() {
				var that = this;
				that.$api.HtppRequest(
					'SystemData/CollegesMold',
					'GET', {},
					function(res) {
						console.log('院校类型', res);
						if (res.code == 0) {
							var newList = res.data;
							// that.typeList= [
							// 	{
							// 		name: '不限',
							// 		isClass: true
							// 	}
							// ]
							// if(newList.length>0){
							// 	newList.map(a=>{
							// 		that.typeList.push({
							// 			name: a,
							// 			isClass: false
							// 		})
							// 	});
							// }

							var list = res.data;
							var newList = [{
								name: '不限',
								isSelect: true
							}];
							if (list.length > 0) {
								list.map(a => {
									newList.push({
										name: a,
										isSelect: false
									})
								});
							}

							that.collegeTypeList = newList;

						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 选择查询条件
			ChooseItem: function(index, type) {
				switch (type) {
					case 1:
						if(this.collegeAddressList.length>0)
						{
							this.collegeAddressList.forEach(a=>{
								a.isSelect=false;
							})
						}
						this.collegeAddressList[index].isSelect = true;this.GetCollegeList(1);
						break;
					case 2:
					if(this.collegeTypeList.length>0)
					{
						this.collegeTypeList.forEach(a=>{
							a.isSelect=false;
						})
					}
						this.collegeTypeList[index].isSelect = true;this.GetCollegeList(1);
						break;
					case 3:
					if(this.collegeCharacteristic.length>0)
					{
						this.collegeCharacteristic.forEach(a=>{
							a.isSelect=false;
						})
					}
						this.collegeCharacteristic[index].isSelect = true;this.GetCollegeList(1);
						break;
					case 4:
					if(this.collegeCategory.length>0)
					{
						this.collegeCategory.forEach(a=>{
							a.isSelect=false;
						})
					}
						this.collegeCategory[index].isSelect = true;this.GetCollegeList(1);
						break;
					default:
						break;
				}
			},
			// 获取院校
			GetCollegeList:function(page) {
				var that = this;
				var address=that.collegeAddressList.length>0?that.collegeAddressList.find(a=>a.isSelect).name:'';
				var info1=that.collegeTypeList.find(a=>a.isSelect);
				var info2=that.collegeCharacteristic.find(a=>a.isSelect);
				var info3=that.collegeCategory.find(a=>a.isSelect);
				var type=info1?info1.name:'';
				var chara=info2?info2.name:'';
				var category=info3?info3.name:'';
				address=address=='不限'?'':address;
				type=type=='不限'?'':type;
				chara=chara=='不限'?'':chara;
				category=category=='不限'?'':category;
				that.$api.HtppRequest(
					'SystemData/GetIntendedCollegesByPage',
					'POST',
					{
						page: page,
						size: 10,
						name: that.searchKey,
						Primarily: 1, // 1.本科 2.专科
						Location: address, // 所在地
						Type1: type , // 院校类型
						Type2: category, // 院校类别
						Feature: chara // 特色
					},
					function(res) {
						console.log('获取列表', res);
						if (res.flag) {
							var list = res.list;
							var newList=page>1?that.collegeList:[];
							list.map(a=>{
								newList.push(a);
							})
							that.collegeList=newList;
							that.page=page;
			// 				if (res.list.length > 0) {
			// 					res.list.map(a => {
			// 						list.push(a);
			// 					});
			// 					that.yxpage = pg;
			
			// 					if (res.list.length < 10) {
			// 						that.Nobusy2 = true;
			// 					}
			// 				} else {
			// 					if (pg >= 1) {
			// 						that.Nobusy2 = true;
			// 					}
			// 				}
			// 				that.listName = list;
			// 				if (that.yxList.length > 0) {
			// 					that.setListYX();
			// 				}
						} 
						// that.busy2 = false;
					},
					function(err) {
						console.log(err);
					}
				);
			},
			GetMore:function() {
				var page =this.page;
				page++;
				this.GetCollegeList(page);
			},
			//院校详情
			GoSchool:function(name){
				var routeUrl = this.$router.resolve({
					path: '/schoolinfo',
					query: {
						schoolname: name
					}
				});
				window.open(routeUrl.href, '_blank');
				
			},
			scrollEvent(e) {
				const scrollBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
				if (scrollBottom < 10) {
					console.log('aaa');
					if (!this.listLoading && !this.listFinished) {
						this.GetList(this.page + 1);
					}
				}
			},
			leiClick(index) {
				this.isLei = index;
				if (index === 0) {
					this.typeList.map(el => {
						el.isClass = false;
					});
					this.typeList[index].isClass = true;
				} else {
					this.typeList[0].isClass = false;
					this.typeList[index].isClass = !this.typeList[index].isClass;
				}
				const idx = this.typeList.findIndex(el => {
					return el.isClass;
				});
				if (idx === -1) {
					this.typeList[0].isClass = true;
				}
				this.GetList(1);
			},
			// 2.23
			getRegionByPid(pid) {
				var that = this;
				that.$api.HtppRequest(
					'SystemData/GetRegionByPid?pid=' + pid,
					'GET', {},
					function(res) {
						console.log('省份', res);
						if (res.flag) {
							var clist = res.list;
							clist.map(a => {
								a.isClass = false;
								that.cityList.push(a);
							});
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 个人中心
			goMyCenter() {
				this.$router.push('/myIndex');
			},

			// 获取其他页
			GetPageList: function(val) {
				var that = this;
				that.GetList(val);
				console.log(`当前页: ${val}`);
			},
			// 获取列表
			GetList: function(page) {
				var that = this;
				let territory = that.cityList
					.filter(el => {
						return el.isClass;
					})
					.map(el => {
						return el.Name;
					})
					.join();
				if (territory === '不限') {
					territory = '';
				}
				// 院校类型
				let collegesMold = that.typeList
					.filter(el => {
						return el.isClass;
					})
					.map(el => {
						return el.name;
					})
					.join();
				if (collegesMold === '不限') {
					collegesMold = '';
				}
				var data = {
					page: page,
					size: that.pageSize,
					colleges: that.colleges,
					territory: territory,
					cityName: '',
					keyDisciplines: '',
					educational: that.educational,
					N985: that.isNine === '是' ? 1 : 0,
					N211: that.isTow === '是' ? 1 : 0,
					NDouble: that.program === '是' ? 1 : 0,
					CountryImportant: that.firstClass === '是' ? 1 : 0,
					ProvinceImportant: that.provinceClass === '是' ? 1 : 0,
					CollegesMold: collegesMold
				};
				that.listLoading = true;
				console.log(data);
				that.$api.HtppRequest(
					'SystemData/GetCollegesDataList',
					'POST',
					data,
					function(res) {
						console.log('获取列表');
						console.log(res);
						that.listLoading = false;
						if (res.flag) {
							var list = res.list;
							that.totleNum = res.totle;
							if (page === 1) {
								that.list = [];
							}
							that.listFinished = list.length < that.pageSize;
							if (list.length > 0) {
								that.page = page;
								for (var i = 0; i < list.length; i++) {
									that.list.push(list[i]);
								}
							}
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},

			// 获取代理城市
			GetCity: function() {
				var that = this;
				that.$api.HtppRequest(
					'SystemData/GetShopCity',
					'GET', {},
					function(res) {
						console.log('获取代理城市');
						console.log(res);
						if (res.flag) {
							var List = res.list;
							for (var i = 0; i < List.length; i++) {
								that.cityList.push(List[i]);
							}
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			classFiyClick(index) {
				this.isClassfiy = index;
				if (index === 0) {
					this.educational = '';
				}
				if (index === 1) {
					this.educational = '本科';
				}
				if (index === 2) {
					this.educational = '专科';
				}
				this.GetList(1);
			},
			collegeTypeClick: function(index) {
				this.collegeTypeList[index].isClass = !this.collegeTypeList[index].isClass;
				this.GetList(1);
			},
			cityClick(index) {
				this.isCity = index;
				this.isNine = '';
				this.isTow = '';
				this.firstClass = '';
				this.provinceClass = '';
				this.program = '';
				if (index === 0) {
					this.featuredList.map(el => {
						el.isClass = false;
					});
					this.featuredList[0].isClass = true;
				} else {
					this.featuredList[0].isClass = false;
					this.featuredList[index].isClass = !this.featuredList[index].isClass;
				}
				const idx = this.featuredList.findIndex(el => {
					return el.isClass;
				});
				if (idx === -1) {
					this.featuredList[0].isClass = true;
				}
				const keys = ['isNine', 'isTow', 'program', 'firstClass', 'provinceClass'];
				this.featuredList.forEach(el => {
					if (el.isClass && el.value > 0) {
						this.$set(this, keys[el.value - 1], '是');
					}
				});
				console.log(this.isNine);
				console.log(this.isTow);
				console.log(this.program);
				console.log(this.firstClass);
				console.log(this.provinceClass);
				this.GetList(1);
			},
			territoryyClick(index) {
				this.isTerritory = index;
				if (index > 0) {
					this.territory = this.cityList[index].Name;
				}
				if (index === 0) {
					// 点击了不限
					this.cityList.map(el => {
						el.isClass = false;
					});
					this.cityList[index].isClass = true;
				} else {
					this.cityList[0].isClass = false;
					this.cityList[index].isClass = !this.cityList[index].isClass;
				}
				const idx = this.cityList.findIndex(el => {
					return el.isClass;
				});
				if (idx === -1) {
					this.cityList[0].isClass = true;
				}
				this.GetList(1);
			}
		}
	};
</script>

<style scoped>
	.label p {
		font-size: 14px;
		min-width: 40px;
		height: 26px;
		float: left;
		margin-right: 10px;
		border-radius: 2px;
		color: #f59a23;
		text-align: center;
		line-height: 26px;
		background-color: #ffefda;
	}

	.label {
		overflow: hidden;
		margin-top: 18px;
	}

	.school_div p span {
		color: #333;
	}

	.school_div p {
		font-size: 14px;
		color: #999;
		float: left;
		width: 20%;
		margin-top: 18px;
	}

	.school_div {
		overflow: hidden;
	}

	.school_left {
		overflow: hidden;
		width: calc(100% - 240px);
	}

	.school_you hgroup a:last-child {
		margin-right: 0;
	}

	.school_you hgroup a {
		font-size: 14px;
		color: #333;
		margin-right: 30px;
		display: inline-block;
		padding-bottom: 5px;
		position: relative;
		cursor: pointer;
	}

	.school_you hgroup a::after {
		content: '';
		width: 62px;
		height: 2px;
		background-color: #333;
		background-color: #333;
		position: absolute;
		left: 0;
		bottom: 0;
		z-index: 10;
	}

	.school_you hgroup a:hover {
		opacity: 0.7;
	}

	.school_you hgroup {
		overflow: hidden;
		margin-top: 18px;
	}

	.school_right h6 {
		font-size: 16px;
		color: #333;
	}

	.school_right {
		overflow: hidden;
		width: calc(100% - 130px);
	}

	.list_pic {
		width: 100px;
		height: 100px;
		overflow: hidden;
		border-radius: 50px;
		background: url(../../../image/noa.png) no-repeat left top;
		background-size: 100% 100%;
	}

	.list_pic img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.school_list li:first-child {
		margin-top: 0;
	}

	.school_list li {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		padding: 30px;
		margin-top: 20px;
	}

	.school_list {
		overflow: hidden;
	}

	/* school_list */

	.table li p {
		font-size: 14px;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	/* 01 */
	.fenNum_div p {
		width: 66px;
		height: 30px;
		font-size: 14px;
		color: #666666;
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		border-radius: 4px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-right: 50px;
		padding: 0 4px;
	}

	.fenNum_div p:nth-child(n + 9) {
		margin-top: 4px;
	}

	.fenNum_div p:hover {
		opacity: 0.7;
	}

	.fenNum_div p.on:hover {
		opacity: 1;
	}

	.fenNum_div p.on {
		background-color: #333;
		color: #fff;
	}

	.fenNum_div {
		width: calc(100% - 150px);
		margin-left: 20px;
	}

	.major-share label {
		font-size: 14px;
		color: #333;
		display: block;
		width: 100px;
		line-height: 40px;
		text-align: right;
	}

	.major-share ul li {
		margin-top: 10px;
	}

	.major-share ul {
		overflow: hidden;
	}

	/* major-share */

	.gaokao-btn {
		width: 90px;
		font-size: 14px;
		margin-left: 0 !important;
	}

	.fenNum_head p.on {
		background-color: #333;
		color: #fff;
	}

	.fenNum_head p.on:hover {
		opacity: 1;
	}

	.fenNum_head p {
		font-size: 16px;
		color: #333;
		width: 180px;
		height: 38px;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		float: left;
		border: solid 1px #333;
		border-bottom: none;
		text-align: center;
		line-height: 38px;
		cursor: pointer;
	}

	.fenNum_head p:hover {
		opacity: 0.7;
	}

	.fenNum_head {
		overflow: hidden;
		border-bottom: solid 2px #333;
		margin-top: 40px;
	}

	/* fenNum_head */

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
		padding-bottom: 60px;
	}

	/* major-share */
	.major-share {
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #eaeaea;
		margin: 20px auto 30px auto;
		padding: 30px 0;
	}

	.major-share-con {
		width: 75%;
		height: auto;
		overflow: ;
		display: flex;
		flex-wrap: wrap;
	}

	.share-li {
		width: 50%;
		display: flex;
		align-items: center;
		/* justify-content: center; */
		margin: 0 0 10px 0;
	}

	.share-li p {
		font-size: 14px;
		color: #333;
		width: 100px;
		text-align: right;
		margin-right: 20px;
	}

	.share-li input {
		width: 270px;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		display: block;
		border-radius: 5px;
		background-color: #fff;
		color: #333;
		font-size: 14px;
	}

	.share-li input::-webkit-input-placeholder {
		color: #999;
	}

	.share-li input:-moz-placeholder {
		color: #999;
	}

	.share-li input:-ms-input-placeholder {
		color: #999;
	}

	.sjWidth {
		width: 270px;
	}

	.major-btn01 {
		width: 25%;
		display: flex;
		align-items: flex-end;
	}

	.major-btn01 button {
		margin: 10px auto;
	}

	/* major-list */
	.major-list {
		width: 100%;
		height: auto;
		margin-top: 15px;
	}

	.major-list ul {
		width: 100%;
		height: auto;
	}

	.major-list ul li {
		border: 1px solid #eee;
		width: 100%;
		height: auto;
		padding: 20px 30px;
		margin-bottom: 20px;
		position: relative;
	}

	.major-li01 {
		width: 100%;
		height: auto;
		display: flex;
		align-items: center;
	}

	.major-li-btn {
		width: 23%;
	}

	.major-li-btn p {
		width: 130px;
		height: 33px;
		line-height: 33px;
		text-align: center;
		background-color: #333;
		font-size: 16px;
		color: #fff;
		border-radius: 50px;
	}

	.major-li01-right {
		width: 80%;
		display: flex;
	}

	.major-li01-right p {
		width: 20%;
		display: flex;
		align-items: center;
		line-height: 33px;
	}

	.major-li01-right p span {
		font-size: 15px;
		color: #999;
	}

	.major-li01-right p span:last-child {
		color: #333;
	}

	.major-li02 {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.major-li02 p {
		font-size: 14px;
	}

	.major-txt01 {
		width: 75px;
		color: #999;
	}

	.major-txt02 {
		width: calc(100% - 120px);
		color: #333;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.major-more {
		width: 45px;
		color: #333;
		text-align: right;
		cursor: pointer;
	}

	.major-txt04 {
		color: #333;
	}

	.major-more-con {
		position: absolute;
		width: 98%;
		height: auto;
		background: rgba(0, 0, 0, 0.7);
		padding: 20px;
		font-size: 15px;
		color: #fff;
		left: 1%;
		bottom: 0;
		border-radius: 5px;
		margin-bottom: -14px;
		z-index: 1;
	}

	.major-more-con::after {
		position: absolute;
		content: '';
		right: 0;
		top: 0;
		width: 0;
		height: 0;
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		border-bottom: 14px solid rgba(0, 0, 0, 0.7);
		margin-top: -14px;
		margin-right: 24px;
	}

	.major-page {
		margin-bottom: 30px;
	}

	.widthx {
		margin-top: 20px;
		margin-bottom: 10px;
	}

	.widthx .major-li01-right {
		width: 100%;
	}

	.widthx .major-li01-right p:first-child {
		min-width: 22.2%;
	}

	.widthx .major-li01-right p:nth-child(2) {
		width: 32.3%;
	}

	.lastIndex .major-li01-right p {
		width: 35%;
	}

	.zhuan_bai button {
		width: 200px;
		height: 40px;
		border-radius: 4px;
		background-color: #444444;
		font-size: 14px;
		color: #fff;
		text-align: center;
		line-height: 40px;
		margin: 0 auto;
		display: block;
		cursor: pointer;
	}

	.city_gao li {
		width: 33.33%;
	}

	.city_gao {
		height: 300px;
		overflow: auto;
	}

	.zhuan_bai>img {
		display: block;
		width: 20px;
		height: 20px;
		position: absolute;
		right: 20px;
		top: 20px;
		z-index: 2;
		cursor: pointer;
	}

	.zhuan_list p {
		width: 130px;
		height: 40px;
		background-color: #e6e6e6;
		text-align: center;
		line-height: 40px;
		text-align: center;
		font-size: 14px;
		border-radius: 4px;
		margin-top: 14px;
		margin-right: 20px;
	}

	.zhuan_list p:active {
		background-color: #00527020;
	}

	.zhuan_list p:nth-child(3n + 3) {
		margin-right: 0;
	}

	.zhuan_h6 {
		text-align: center;
		font-size: 18px;
		color: #333333;
		font-weight: normal;
	}

	.zhuan_bai {
		border-radius: 10px;
		width: 510px;
		overflow: hidden;
		padding: 20px 40px;
		background-color: #fff;
		position: relative;
	}

	/* zhuan_bai */

	.tb_city li p {
		width: 24px;
		height: 24px;
		border-radius: 50px;
		background-color: #005270;
		color: #fff;
		text-align: center;
		line-height: 24px;
		font-size: 12px;
		text-align: center;
		line-height: 24px;
		position: absolute;
		right: -9px;
		top: -9px;
		margin: 0;
		z-index: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.yi_hot_div p.on {
		color: #fff;
		background-color: #005371;
		border: solid 1px #005371;
	}

	.yi_hot_div p {
		width: 90px;
		height: 36px;
		box-sizing: border-box;
		padding: 0 10px;
		font-size: 14px;
		color: #666666;
		text-align: center;
		line-height: 36px;
		border: solid 1px #444444;
		cursor: pointer;
		margin-right: 10px;
		margin-top: 10px;
	}

	.yi_hot_div {
		width: calc(100% - 92px);
	}

	.yi_hot>p {
		font-size: 14px;
		color: #333333;
		line-height: 36px;
		margin-top: 10px;
	}

	.yi_hot {
		padding: 14px 0;
	}

	.yi_head p span {
		color: #0079fe;
	}

	.yi_head p {
		font-size: 14px;
		color: #333333;
	}

	.yi_head button {
		width: 70px;
		height: 30px;
		background-color: #fff;
		border-radius: 4px;
		border: solid 1px #dedede;
		text-align: center;
		line-height: 30px;
		display: block;
		margin: 0 23px;
		cursor: pointer;
	}

	.yi_all span {
		font-size: 14px;
		color: #333333;
	}

	.yi_all img {
		display: block;
		width: 40px;
		height: 40px;
		cursor: pointer;
	}

	.pyx_you p {
		margin-top: 0px;
		min-width: 66px;
		height: 30px;
		font-size: 14px;
		color: #666666;
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		border-radius: 4px;
		margin-right: 30px;
	}

	.pyx_you p.hover {
		opacity: 0.7;
	}

	.pyx_you p.on:hover {
		opacity: 1;
	}

	.pyx_you p.on {
		color: #fff;
		background-color: #005371;
	}

	.pyx_you {
		width: calc(100% - 80px);
	}

	.pyx_h6 {
		font-size: 14px;
		color: #333333;
		width: 80px;
		line-height: 30px;
		margin-top: 10px;
	}

	.yi_xiang li {
		margin-top: 10px;
	}

	/* 2.14 */

	.tb_city li:nth-child(11n + 11) {
		margin-right: 0;
	}

	.tb_city li.on {
		background-color: #333;
		color: #fff;
	}

	.tb_city li {
		width: 96px;
		height: 36px;
		padding: 0 10px;
		background-color: #eeeeee;
		font-size: 14px;
		color: #333;
		cursor: pointer;
		position: relative;
		border: solid 1px #dddddd;
		margin: 10px 10px 0 0;
	}

	.tb_city li span {
		line-height: 36px;
		display: block;
		text-align: center;
		width: 100%;
		height: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.tb_city>p {
		font-size: 14px;
		color: #333333;
	}

	.tb_zy_you p i {
		cursor: pointer;
		color: #fc8982;
	}

	.tb_zy_you .table li p strong {
		width: calc(100% - 20px) !important;
		font-size: 14px;
		color: #666;
		font-weight: normal;
	}

	.tb_zy_you .table li p {
		text-align: left;
		padding: 0 1em;
	}

	.tb_zy_you .table hgroup p,
	.tb_zy_you .table li p {
		width: 100% !important;
	}

	.tb_zy_you::before {
		content: '';
		width: 25px;
		height: 2px;
		background-color: #f5f5f5;
		position: absolute;
		z-index: 0;
		left: -24px;
		top: 32px;
		margin: 0;
	}

	/* 01 */
	.table p span {
		font-size: 14px;
		color: #333;
		padding-bottom: 8px;
		border-bottom: solid 1px #333;
		line-height: initial;
		margin: 0 10px;
		cursor: pointer;
	}

	.table li p {
		font-size: 14px;
		width: calc(100% / 6);
		text-align: center;
		color: #666666;
		height: fit-content;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table li {
		padding: 20px 0;
		border-bottom: solid 1px #e6e6e6;
	}

	.table ul {
		overflow: auto;
		height: calc(100% - 60px);
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table {
		height: 100%;
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	/* 01 */

	.tb_zy_you {
		width: 226px;
		position: relative;
		z-index: 2;
	}

	.tb_zy_left {
		width: 100%;
		position: relative;
		z-index: 2;
		height: 100%;
	}

	.tbb_box {
		height: 500px;
		margin-top: 20px;
		overflow: hidden;
	}

	/* tbb_box */
	.tba_dl label span {
		color: #ff0000;
	}

	.tba_dl label {
		font-size: 14px;
		color: #333;
		width: 90px;
		text-align: right;
		margin-right: 10px;
	}

	.tba_dl {
		min-width: 320px;
	}

	.tb_zye {
		padding: 20px 30px;
		border: solid 1px #dddddd;
	}

	/* tb_zy */


	.gaokao-content {
		background-color: #fff;
		margin-bottom: 40px;
	}

	.shuJu {
		font-size: 14px;
		padding: 15px 0 0 0;
	}

	.gaokao-btn {
		font-size: 14px !important;
	}
</style>
